import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import heroBg from "@/assets/hero-bg.jpg";

const HeroSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} className="relative min-h-[85vh] md:min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="Peças de património cultural num museu — plataforma Index Rerum"
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
          loading="eager"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 container mx-auto px-5 md:px-4 text-center max-w-4xl">
        <div className="inline-flex items-center border border-white/20 rounded-full px-5 py-2 mb-8 animate-fade-up">
          <span className="text-sm text-white/80 font-medium tracking-wide">Plataforma 100% Web</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight animate-fade-up animation-delay-100 text-balance drop-shadow-lg">
          Onde o Património{"\n"}encontra a{" "}
          <span className="italic">Gestão Inteligente.</span>
        </h1>

        <p className="mt-6 text-lg md:text-xl text-white/80 max-w-2xl mx-auto animate-fade-up animation-delay-200 font-light leading-relaxed drop-shadow-md">
          O Index Rerum é um sistema de inventário e gestão de património 100% web,
          desenhado para instituições que exigem rigor científico, flexibilidade total
          e acessibilidade universal.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center animate-fade-up animation-delay-300">
          <Button size="lg" asChild className="bg-white text-foreground font-semibold hover:bg-white/90 transition-all duration-300 text-base px-8 py-3">
            <a href="#contacto">Agendar Demonstração Gratuita</a>
          </Button>
          <Button size="lg" asChild className="border border-white/40 text-white hover:bg-white/10 font-medium transition-all duration-300 bg-transparent text-base px-8 py-3">
            <a href="#funcionalidades">Ver Funcionalidades</a>
          </Button>
        </div>
      </div>
    </section>
  );
});

HeroSection.displayName = "HeroSection";

export default HeroSection;
